import script from "./ActionsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsMenu.vue?vue&type=script&setup=true&lang=js"

import "./ActionsMenu.vue?vue&type=style&index=0&id=4d98ebb5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d98ebb5"]])

export default __exports__